// subtitles.rb, def languages_list
export enum LanguageShortcut {
    pl  = 'pl',
    en  = 'en',
    cs  = 'cs',
    sk  = 'sk',
    de = 'de',
    hu = 'hu',
    ua = 'ua',
    ru = 'ru',
    fr = 'fr',
    // 10
    lt = 'lt',
    it = 'it',
    et = 'et',
    // 14
    si = 'si',
    es = 'es',
    se = 'se',
    fi = 'fi',
    // 19
    ro = 'ro',
    nl = 'nl',
    dk = 'dk',
    // 23
    // 24
    // 25
    hr = 'hr',
    // 27
    // 28
    no = 'no',
}

export type RegulationsLanguage = 'pl' | 'de' | 'en';
export type RegulationsKoltonLanguage = 'pl' | 'en';
export type GeneralPolicyLanguage = 'pl' | 'en';

export type DocumentType = 'regulations' | 'generalPolicy' | 'policy' | 'regulations_rules_service24';

export type Language = LanguageShortcut | 'default' | '';

export type Subtitles = Record<number, string>;

export type SubtitlesData = {
    data: Subtitles;
    languageTag: string;
    lastUpdate: number
    urlParameters: LanguageShortcut;
}

